export const getPortalElement = () =>
    document.querySelector("#portal") ?? document.body;
